module.exports = __webpack_public_path__ + "img/tips_white_withdrawal.28740e9f.gif";